import { Provider, useSelectableContext } from './Provider';
import SelectBox from './SelectBox';
import SelectableToggle from './SelectableToggle';
import SelectableBar from './SelectableBar';

const Selectable = (props) => {
    return <Provider {...props}>
        {props.children}
    </Provider>
};

export default Selectable;

export {
    useSelectableContext as useSelectable,
    SelectBox,
    SelectableToggle,
    SelectableBar,
}
